module.exports = __webpack_public_path__ + "img/8.77250ac4.png";